<template>
<div class="profile-page">

  <div class="profile-container">

    <!-- LEFT PROFILE -->
    <div class="profile-card">

      <div class="avatar-wrap">
        <img :src="previewImage || user.profile_image || defaultAvatar" class="avatar">

        <label class="change-photo">
          Cambiar foto
          <input type="file" hidden @change="handleImageUpload">
        </label>
      </div>

      <h2>{{form.name}}</h2>

      <p class="email">
        {{form.email}}
      </p>

      <!-- PLAN BADGE -->

      <div v-if="subscription.is_active" class="plan-badge active">
        {{subscription.plan_name}} Plan
      </div>

      <div v-else class="plan-badge free">
        Plan gratuito
      </div>

    </div>


    <!-- RIGHT DETAILS -->
    <div class="details-card">

      <h3>Detalles del perfil</h3>

      <form @submit.prevent="updateProfile">

        <div class="form-row">

          <div class="input-box">
            <label>Nombre</label>
            <input v-model="form.name">
          </div>

          <div class="input-box">
            <label>Correo electrónico</label>
            <input v-model="form.email">
          </div>

        </div>

        <div class="input-box">
          <label>Teléfono</label>
          <input v-model="form.phone">
        </div>


        <!-- SUBSCRIPTION -->

        <div class="subscription-box">

          <h4>Afiliación</h4>

          <div v-if="subscription.is_active" class="sub-active">

            <div class="plan">
              {{subscription.plan_name}}
            </div>

            <div class="date">
              Activo desde :
              {{formatDate(subscription.start_date)}}
            </div>

          </div>


          <div v-else class="no-plan">

            <p>Sin suscripción activa</p>

            <button
            type="button"
            class="buy-btn"
            @click="goToSubscription"
            >
            Plan de compra
            </button>

          </div>

        </div>


        <button class="save-btn">

          Actualizar perfil

        </button>

      </form>

    </div>

  </div>

</div>
</template>

<script>
import { HTTP } from '../../_helper/http-constants.js';

export default {

data(){

return{

user:{},

subscription:{},

form:{
name:'',
email:'',
phone:'',
profile_image:null
},

previewImage:null,

defaultAvatar:'https://i.pravatar.cc/150'

}
},

methods:{

async fetchProfile(){

const res = await HTTP.get('/profile');

this.user = res.data.user;

this.form.name = this.user.name;

this.form.email = this.user.email;

this.form.phone = this.user.phone;

},

async fetchSubscription(){

const res = await HTTP.get('/subscription/status');

this.subscription = res.data;

},

handleImageUpload(e){

const file = e.target.files[0];

this.form.profile_image = file;

this.previewImage = URL.createObjectURL(file);

},

async updateProfile(){

const formData = new FormData();

formData.append('name',this.form.name);

formData.append('email',this.form.email);

formData.append('phone',this.form.phone);

if(this.form.profile_image){

formData.append(
'profile_image',
this.form.profile_image
);

}

const res = await HTTP.post(
'/profile/update',
formData
);

if(res.data.status){

alert("Profile updated");

}

},

formatDate(date){

return new Date(date)
.toLocaleDateString();

},

goToSubscription(){

this.$router.push('/subscription');

}

},

mounted(){

this.fetchProfile();

this.fetchSubscription();

}

}
</script>

<style scoped>

.profile-page{

min-height:100vh;

background:#000;

padding:40px 20px;

display:flex;

justify-content:center;

align-items:center;

}


.profile-container{

width:1100px;

display:grid;

grid-template-columns:320px 1fr;

gap:30px;

}


/* PROFILE CARD */

.profile-card{

background:#111;

padding:30px;

border-radius:20px;

text-align:center;

box-shadow:0 0 30px rgba(0,255,255,0.08);

}


.avatar{

width:130px;

height:130px;

border-radius:50%;

object-fit:cover;

border:4px solid #00d9ff;

}


.change-photo{

display:block;

margin-top:10px;

font-size:13px;

color:#00d9ff;

cursor:pointer;

}


.email{

color:#888;

font-size:14px;

margin-top:5px;

}


.plan-badge{

margin-top:15px;

padding:8px;

border-radius:30px;

font-size:13px;

}


.plan-badge.active{

background:#003c3c;

color:#00ffd5;

}


.plan-badge.free{

background:#222;

color:#aaa;

}



/* DETAILS */

.details-card{

background:#111;

padding:35px;

border-radius:20px;

box-shadow:0 0 30px rgba(0,255,255,0.05);

}


.form-row{

display:grid;

grid-template-columns:1fr 1fr;

gap:20px;

}


.input-box{

margin-bottom:20px;

}


.input-box label{

display:block;

color:#888;

font-size:13px;

margin-bottom:5px;

}


.input-box input{

width:100%;

padding:12px;

background:#000;

border:1px solid #333;

border-radius:8px;

color:white;

}


.input-box input:focus{

border-color:#00e1ff;

outline:none;

}


.subscription-box{

margin-top:30px;

background:#0b0b0b;

padding:20px;

border-radius:15px;

}


.plan{

font-size:18px;

color:#00ffd5;

}


.date{

font-size:13px;

color:#888;

margin-top:5px;

}


.no-plan{

text-align:center;

}


.buy-btn{

margin-top:10px;

padding:10px 25px;

border:none;

border-radius:30px;

background:linear-gradient(45deg,#00e1ff,#0066ff);

color:white;

cursor:pointer;

}


.save-btn{

margin-top:25px;

width:100%;

padding:14px;

border:none;

border-radius:30px;

background:linear-gradient(45deg,#00e1ff,#0066ff);

font-weight:600;

cursor:pointer;

}


/* MOBILE */

@media(max-width:900px){

.profile-container{

grid-template-columns:1fr;

}

.form-row{

grid-template-columns:1fr;

}

}

</style>